import { useMemo } from 'react';
import { useUserInfo } from './useUserInfo';

/**
 * Hook to check if the current portal is ungated for one or more gates
 * @param gateNames - Single gate name or array of gate names (should be from the gates constants)
 * @returns boolean indicating if the portal is ungated for the gate(s). For multiple gates, returns true only if ALL gates are ungated
 */
export function useIsUngated(gateNames) {
  const userInfo = useUserInfo();
  return useMemo(() => {
    if (!userInfo || !userInfo.gates) {
      return false;
    }
    if (Array.isArray(gateNames)) {
      if (gateNames.length === 0) {
        return true; // Empty array means no gates to check
      }
      const gatesSet = new Set(userInfo.gates);
      return gateNames.every(gateName => gatesSet.has(gateName));
    }
    return userInfo.gates.includes(gateNames);
  }, [userInfo, gateNames]);
}